var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeleteOutline = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.988 6.75v7.488H6.012V6.75h5.976zm-1.125-4.5H7.137l-.774.738H3.762V4.5h10.476V2.988h-2.601l-.774-.738zM13.5 5.238h-9v9a1.5 1.5 0 001.512 1.512h5.976a1.5 1.5 0 001.512-1.512v-9z"
  })));
};
export default SvgDeleteOutline;